<template>
  <el-dialog
    :title="$t('resourceStoreType.addType')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('resourceStoreType.typeName')" prop="name">
        <el-input
          v-model="form.name"
          :placeholder="$t('resourceStoreType.typeNamePlaceholder')"
        />
      </el-form-item>
      <el-form-item :label="$t('resourceStoreType.typeDesc')" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :placeholder="$t('resourceStoreType.typeDescPlaceholder')"
          :rows="4"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveResourceStoreType } from '@/api/housekeeping/resourceStoreTypeApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddResourceStoreType',
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        description: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('resourceStoreType.typeNameRequired'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('resourceStoreType.typeDescMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const params = {
              ...this.form,
              shopId: getShopId()
            }
            await saveResourceStoreType(params)
            this.$message.success(this.$t('common.submitSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('添加失败:', error)
          }
        }
      })
    }
  }
}
</script>